import { RESIDENT_LIBERTY_ROLES } from '../constants/residentConstants'
import type { PublicNotesNotifySelection } from '../types'
import type { DefaultApiPage } from './residentDecoupling'

/**
 * Builds `POST /api/default/:userId` body for public notes/messages.
 * Mirrors Angular `sendNoteMessage` → `sendMessage` / `sendNotes`.
 * `page` is resident|default so backend keys notes/messages as RESIDENT* vs DEFAULT*.
 */
export function buildPublicNotesSavePayload(
  message: string,
  applicationId: string | number | undefined,
  roleName: string,
  selection: PublicNotesNotifySelection,
  page: DefaultApiPage = 'default',
): Record<string, unknown> {
  const payload: Record<string, unknown> = { page }
  if (applicationId != null && String(applicationId).trim() !== '') {
    payload.application_id = applicationId
  }

  const propertySelected = selection.email_sendto_property === 'property'
  const emailSendTo = selection.email_sendto ?? ''

  if (emailSendTo === 'none') {
    payload.notes = message
    return payload
  }

  if (['default_manager', 'success_manager', 'default_success'].includes(emailSendTo)) {
    payload.message = message
    payload.send_to = 'liberty'
    payload.email_sendto = emailSendTo
    if (propertySelected) {
      payload.email_sendtoproperty = 'property'
    }
    return payload
  }

  if (propertySelected) {
    payload.message = message
    payload.send_to = RESIDENT_LIBERTY_ROLES.includes(roleName) ? 'property' : 'liberty'
    return payload
  }

  throw new Error('Please select an option!')
}

export function isPublicNotesNotifySelectionValid(selection: PublicNotesNotifySelection): boolean {
  return Boolean(selection.email_sendto || selection.email_sendto_property)
}

export type { PublicNotesNotifySelection } from '../types'
